import React, { createContext, useEffect, useState } from 'react';
import { fetchData } from './Apis/FetchData';
import { API_URL } from "./Apis/config";

// Create the context
export const MyContext = createContext();



// Create a provider component
export const MyProvider = ({ children }) => {
    const [userData,setUserData]=useState([]);//[]
    const [eventData,setEventData]=useState([]);//[]
    const [assigneeData,setAssigneeData]=useState([]);//[]
    const [appointData,setAppointData]=useState([]);//[]
    const [horoData,setHoroData]=useState([]);//[]
    const [youtubes, setYoutubes] = useState({});//{}
    // const [mainData,setMainData]=useState(null);
    //[]
    // const [subData,setSubData]=useState(null);
    //[]



  
  
  useEffect(() => {
   
if(userData.length==0)userApi();
if(eventData.length==0)eventApi();
if(assigneeData.length==0)assigneeApi();
if(appointData.length==0)appointApi();
if(horoData.length==0)horoApi();
if(Object.keys(youtubes).length==0)youtubesApi();

// if(!mainData)mainApi();
// if(!subData)subApi();
    
  }, []);


  async function userApi(){
    const userApiData=await fetchData(`${API_URL}/users`);
    setUserData(userApiData);
  }
  async function eventApi(){
    const eventApiData=await fetchData(`${API_URL}/event`);
    setEventData(eventApiData);
  }
  async function assigneeApi(){
    const assigneeApiData=await fetchData(`${API_URL}/assignee`);
    setAssigneeData(assigneeApiData);
  }
  async function appointApi(){
    const appointApiData=await fetchData(`${API_URL}/appointment`);
    setAppointData(appointApiData);
  }
  async function horoApi(){
    const horoApiData=await fetchData(`${API_URL}/horo`);
    setHoroData(horoApiData);
  }
  async function youtubesApi(){
    const youtubesApiData=await fetchData(`${API_URL}/youtube`);
    setYoutubes(youtubesApiData);
  }
  // async function mainApi(){
  //   const mainApiData=await fetchData(`${API_URL}/main`);
  //   setMainData(mainApiData);
  // }
  // async function subApi(){
  //   const subApiData=await fetchData(`${API_URL}/sub`);
  //   setSubData(subApiData);
  // }


  return (
    <MyContext.Provider value={{userData,userApi,eventData,eventApi,assigneeData,assigneeApi,appointData,appointApi,horoData,horoApi,youtubes,youtubesApi
    // ,mainData,mainApi,subData,subApi
    }}>
      {children}
    </MyContext.Provider>
  );
}

